import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
  closeMobile: () => void;
  isCollapsed: boolean;
  isMobileOpen: boolean;
  openMobile: () => void;
  toggleCollapsed: () => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set, get) => ({
      closeMobile: () => {
        set({ isMobileOpen: false });
      },
      isCollapsed: false,
      isMobileOpen: false,
      openMobile: () => {
        set({ isMobileOpen: true });
      },
      toggleCollapsed: () => {
        set({ isCollapsed: !get().isCollapsed });
      },
    }),
    {
      name: 'ops-utility-hub-sidebar-collapsed',
      // The mobile drawer always starts closed, so only the desktop collapsed preference is saved.
      partialize: ({ isCollapsed }) => ({ isCollapsed }),
    },
  ),
);
